import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "globe-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(2.5 2.5)" },
        React.createElement("circle", { cx: 6, cy: 6, r: 6, stroke: "currentColor" }),
        React.createElement("ellipse", { cx: 6, cy: 6, stroke: "currentColor", rx: 3, ry: 6 }),
        React.createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M5.5 0v12h1V0z" }),
        React.createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M.25 4.5h11.5v-1H.25zm.25 4h11.25v-1H.5z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
